import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculator-modals.component.scss';
import * as $ from 'jquery';
var WpbbsaCalculatorModals = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculatorModals, _super);
    function WpbbsaCalculatorModals(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    WpbbsaCalculatorModals.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-wpbbsa-calculator-modal-open'));
        this.closeButton = this.element.querySelector('.js-wpbbsa-calculator-modal-close');
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-reset'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-calculate'));
        this.calculator = this.element.querySelector('form');
        if (this.calculator) {
            this.calculatorFields = Array.from(this.calculator.querySelectorAll('input'));
        }
        this.calculatorOutput = Array.from(document.querySelectorAll('.wpbbsa-calculator-modals__total'));
        this.calculatorUseExpenses = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-use-expenses'));
    };
    WpbbsaCalculatorModals.prototype.bindEvents = function () {
        var _this = this;
        var totalExpenses = 0;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.calculatorSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var service = _this.wpbbsaCalculatorService;
            totalExpenses = 0;
            _this.calculatorFields.map(function (itemField) {
                if (itemField.value === null || itemField.value === undefined || itemField.value === '') {
                    totalExpenses += 0;
                }
                else {
                    totalExpenses += parseFloat(itemField.value);
                }
            });
            [].slice.call(_this.calculatorOutput).forEach(function (div) {
                div.innerHTML = service.formatter(totalExpenses);
            });
            // Trigger form Complete when the user calculates the results
            _this.analyticsService.dtmFormComplete("complete", "");
        }); });
        this.calculatorUseExpenses.map(function (item) { return item.addEventListener('click', function (event) {
            event.preventDefault();
            var fieldExpense = Array.from(document.querySelectorAll('input[name=monthly_expenses]'));
            fieldExpense.map(function (item) {
                item.value = totalExpenses;
            });
            _this.closeModal();
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        }
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            totalExpenses = 0;
            _this.resetInputs(event);
        }); });
    };
    WpbbsaCalculatorModals.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    WpbbsaCalculatorModals.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (modalId === undefined || modalId === '' || modalId === null) {
            var parentElement = $(element).closest('.js-wpbbsa-calculator-modal-open');
            modalId = parentElement.attr('data-modal');
            console.log('parentElement');
            console.log(parentElement);
        }
        console.log(event);
        console.log(event.target);
        console.log(modalId);
        this.activeModal = this.getModalById(modalId);
        console.log('activeModal');
        console.log(this.activeModal);
        console.log('element');
        console.log(this.element);
        this.openModal();
    };
    WpbbsaCalculatorModals.prototype.closeModal = function () {
        var _this = this;
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    WpbbsaCalculatorModals.prototype.openModal = function () {
        console.log('activeModal');
        console.log(this.activeModal);
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    WpbbsaCalculatorModals.prototype.getModalById = function (id) {
        return this.element.querySelector("#" + id);
    };
    WpbbsaCalculatorModals.prototype.resetInputs = function (event) {
        event.preventDefault();
        this.calculator.reset();
        [].slice.call(this.calculatorOutput).forEach(function (div) {
            div.innerHTML = '0';
        });
        //Analytics - allow user to trigger a new form start on next interaction
        this.analyticsService.dtmRestartForm();
    };
    return WpbbsaCalculatorModals;
}(Base));
export { WpbbsaCalculatorModals };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculator-modals/wpbbsa-calculator-modals.component.ts
// module id = 1013
// module chunks = 0